module.exports = __webpack_public_path__ + "img/brand-lexus.fea6a03f.png";